import { FC, useMemo } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

import { ClockIcon } from "../../../icons";
import { isValidDate } from "../../../../utils";
import { RoutesMap } from "../../../../routes.tsx";

interface Props {
  isActive: boolean | undefined;
  finishedAt: string | undefined;
}

export const MainPageCoolingPeriod: FC<Props> = ({ isActive, finishedAt }) => {
  const endDate = useMemo(() => {
    if (!isValidDate(finishedAt)) {
      return "до ...";
    }

    const rawDate = new Date(finishedAt!);
    const formattedDate = new Intl.DateTimeFormat("ru-RU", {
      dateStyle: "short",
      timeStyle: "short",
      hourCycle: "h23",
    }).format(rawDate);

    return `до ${formattedDate}`;
  }, [finishedAt]);

  if (isActive === false) {
    return null;
  }

  return (
    <Box
      as={RouterLink}
      to={RoutesMap.cooling}
      w="100%"
      px="16px"
      py="18px"
      bg="white"
      borderRadius="16px"
    >
      <HStack justifyContent="space-between">
        <HStack spacing={4}>
          <Icon as={ClockIcon} boxSize="24px" />

          <Box>
            <Text variant="brand">Можно отказаться от займа</Text>
            <Text fontSize="12px">{endDate}</Text>
          </Box>
        </HStack>

        <Icon as={ChevronRightIcon} color="purple.500" strokeWidth="2px" mr="3px" />
      </HStack>
    </Box>
  );
};
